import type { SchemaBonitaetsRechnung } from 'cpool-schemas/src/LoanRequest/Europace/Angebote/BonitaetsRechnung.schema';
import { useTranslation } from 'react-i18next';

import { HouseholdBudgetSection } from './HouseholdBudgetSection';
import { HouseholdBudgetTotal } from './HouseholdBudgetTotal';

type Props = {
    householdBudget?: SchemaBonitaetsRechnung;
    showTitle?: boolean;
};

type BudgetPositions = NonNullable<NonNullable<SchemaBonitaetsRechnung['einnahmen']>['positions']>;

const toLabelsAndValues = (positions: BudgetPositions | undefined) => ({
    labels: positions?.map((item) => item.label ?? '') ?? [],
    values: positions?.map((item) => Number(item.value)) ?? [],
});

export const CreditWorthiness: React.FC<Props> = ({ householdBudget, showTitle = true }) => {
    const { t } = useTranslation();
    const incomeData = toLabelsAndValues(householdBudget?.einnahmen?.positions);
    const expensesData = toLabelsAndValues(householdBudget?.ausgaben?.positions);
    const hasData = incomeData.values.length > 0 || expensesData.values.length > 0;

    return (
        <div className="flex flex-col gap-3">
            {showTitle && (
                <h6 className="text-lg font-medium text-midnight">
                    {t('BANK_CREDIT_REQUEST.ADDITIONAL_INFO.HOUSEHOLD_CALCULATION')}
                </h6>
            )}
            {!hasData && (
                <div className="italic text-grey">
                    {t('BANK_CREDIT_REQUEST.ADDITIONAL_INFO.NO_CREDIT_RATING_CALCULATION')}
                </div>
            )}
            {incomeData.values.length > 0 && (
                <HouseholdBudgetSection
                    labels={incomeData.labels}
                    values={incomeData.values}
                    mainTitle={t('BANK_CREDIT_REQUEST.ADDITIONAL_INFO.INCOME')}
                    subTitle={t('BANK_CREDIT_REQUEST.ADDITIONAL_INFO.TOTAL_INCOME')}
                    total={Number(householdBudget?.einnahmen?.total ?? 0)}
                />
            )}
            {expensesData.values.length > 0 && (
                <HouseholdBudgetSection
                    labels={expensesData.labels}
                    values={expensesData.values}
                    mainTitle={t('BANK_CREDIT_REQUEST.ADDITIONAL_INFO.EXPENSES')}
                    subTitle={t('BANK_CREDIT_REQUEST.ADDITIONAL_INFO.TOTAL_EXPENSES')}
                    total={Number(householdBudget?.ausgaben?.total ?? 0)}
                />
            )}
            {hasData && <HouseholdBudgetTotal total={Number(householdBudget?.total ?? 0)} />}
        </div>
    );
};
